/**
 * 移动端适配工具
 * 提供检测设备类型和适配移动端显示的相关功能
 */
import { ref, onMounted, onUnmounted } from 'vue'

/**
 * 判断当前设备是否为移动端
 * @param {Number} breakpoint 断点值，默认为768px
 * @returns {Boolean} 是否是移动端设备
 */
export const isMobileDevice = (breakpoint = 768) => {
  return window.innerWidth <= breakpoint
}

/**
 * 创建响应式的移动设备监听
 * @param {Number} breakpoint 断点值，默认为768px
 * @returns {Object} 包含isMobile响应式引用
 */
export const useMobileDetection = (breakpoint = 768) => {
  const isMobile = ref(false)
  
  const checkMobile = () => {
    isMobile.value = window.innerWidth <= breakpoint
  }
  
  onMounted(() => {
    checkMobile()
    window.addEventListener('resize', checkMobile)
  })
  
  onUnmounted(() => {
    window.removeEventListener('resize', checkMobile)
  })
  
  return { isMobile }
}

/**
 * 移动端卡片视图样式
 * 返回适用于移动端卡片视图的CSS样式对象
 */
export const mobileCardStyles = {
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '10px 0'
  },
  card: {
    backgroundColor: '#fff',
    marginBottom: '15px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    transition: 'all 0.3s ease'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '5px',
    backgroundColor: '#f9fafc',
    padding: '12px 15px',
    borderBottom: '1px solid #ebeef5'
  },
  cardContent: {
    padding: '12px 15px'
  },
  cardItem: {
    position: 'relative',
    padding: '8px 0',
    borderBottom: '1px solid #f0f2f5',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cardActions: {
    backgroundColor: '#f9fafc',
    padding: '10px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '8px',
    borderTop: '1px solid #ebeef5'
  }
}

/**
 * 适配移动端表格查询区域
 * 返回适用于移动端表格查询区的CSS样式对象
 */
export const mobileFilterStyles = {
  filterContainer: {
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '10px'
  },
  filterItem: {
    width: '100%',
    marginBottom: '10px'
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    marginTop: '10px'
  }
}

/**
 * 适配移动端分页器
 * 返回适用于移动端分页器的CSS样式对象
 */
export const mobilePaginationStyles = {
  paginationContainer: {
    width: '100%',
    padding: '10px 5px',
    whiteSpace: 'normal',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px'
  }
}